const styles = {
  filterRow: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
  },
  filterLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  filterLabel: {
    fontSize: '0.875rem',
    fontWeight: 600,
  },
};

export default styles;
